<template>
  <div v-if="showView">
    <header class="header fixed-top">
      <nav class="navbar navbar-light bg-light">
        <div class="container navbarCont" style="padding: 0">
          <a class="navbar-brand">
            <img src="../assets/logo3.png" class="logo" />
          </a>
          <form class="form-inline searchbox">
            <input
              type="text"
              class="navInput"
              placeholder="请输入关键字"
              placeholder-class="ipt"
            />
            <button class="navbtn" type="submit">
              <img src="../assets/search.png" class="searchico" />
              搜索
            </button>
          </form>
        </div>
      </nav>
      <nav
        class="navbar navbar-expand-lg navbar-light"
        :class="[scrollTop > 100 ? 'shadow' : '']"
        :style="{ background: backgroundColor }"
      >
        <div
          class="container navBox"
          style="display: flex; justify-content: flex-end"
        >
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarsExampleDefault"
            aria-controls="navbarsExampleDefault"
            aria-expanded="false"
            aria-label="Toggle navigation"
            @click="collapseNav"
          >
            <span class="navbar-toggler-icon">
              <img v-if="isCollapse" :src="bgimg1" />
              <img v-else :src="bgimg2" />
            </span>
          </button>

          <div
            class="collapse navbar-collapse"
            id="navbarsExampleDefault"
            style="justify-content: center"
          >
            <ul class="navbar-nav">
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/"
                  >首页</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/about"
                  >关于我们</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/product"
                  >产品中心</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/support"
                  >技术支持</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/news"
                  >新闻动态</router-link
                >
              </li>
              <li
                class="nav-item"
                :class="[scrollTop > 100 ? 'active2' : 'active']"
              >
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/contact"
                  >联系我们</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/hire"
                  >人才招聘</router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
    <div class="spacebox"></div>
    <main>
      <!-- 顶部图 -->
      <div class="pictureBox" v-if="picture">
        <img :src="picture.P_IMG" />
      </div>

      <!-- 联系我们 -->
      <div class="contact container-fluid">
        <div class="toptitle">
          <img src="../assets/zszs.png" />
          <span>联系我们</span>
          <img src="../assets/zszs2.png" />
        </div>
        <div class="cont">
          <img :src="sites" class="sites" />
          <div class="list">
            <div class="row contact-item">
              <div class="col-2">区域</div>
              <div class="col-10" style="text-align: center">联系方式</div>
            </div>
            <template style="height: 81.625rem; overflow-y: scroll">
              <div
                class="row contact-item"
                v-for="(item, index) in cityList"
                :key="index"
              >
                <div class="col-2 area">{{ item.C_NAME }}</div>
                <div class="col-10 desc">{{ item.C_AREA }}</div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <!-- 在线留言 -->
      <div class="message">
        <div class="toptitle">
          <img src="../assets/zszs.png" />
          <span>在线留言</span>
          <img src="../assets/zszs2.png" />
        </div>
        <div class="msgnote">
          <p>
            感谢您浏览采航(上海)贸易有限公司官网，我们十分重视您的意见和咨询
          </p>
          <p>
            如果您对采航(上海)贸易有限公司产品和服务有任何咨询，请填写如下表单，我们将尽快与您取得联系。
          </p>
        </div>
        <form class="formCont container" @submit.prevent="submit">
          <div class="form-row" style="margin: 0">
            <div
              class="form-group col-md-8 flexStart formGroup3"
              style="margin-bottom: 3.8125rem"
            >
              <label>标题*</label>
              <input type="text" class="form-control" v-model="title" />
            </div>
            <div
              class="form-group col-md-4 flexStart formGroup3"
              style="margin-bottom: 3.8125rem"
            >
              <label>姓名*</label>
              <input type="text" class="form-control" v-model="name" />
            </div>
          </div>
          <div class="form-row" style="margin: 0">
            <div class="form-group col-md-4 flexStart formGroup4">
              <label>电子邮箱*</label>
              <input type="email" class="form-control" v-model="email" />
            </div>
            <div class="form-group col-md-4 flexStart formGroup4">
              <label>手机号码*</label>
              <input
                type="tel"
                class="form-control"
                v-model="telephone"
                maxlength="11"
              />
            </div>
            <div class="form-group col-md-4 flexStart formGroup4">
              <label>固定电话</label>
              <input type="text" class="form-control" v-model="telephone1" />
            </div>
          </div>
          <div class="form-group flexStart" style="margin-bottom: 0">
            <label>内容*</label>
            <textarea class="form-control" rows="5" v-model="desc"></textarea>
          </div>
          <button type="submit" class="contactBtn">
            <span>提交信息</span>
            <img src="../assets/tj.png" />
          </button>
        </form>
      </div>

      <!-- 提醒弹窗 -->
      <div class="modal-bg" v-show="isShow4">
        <div class="modal-container">
          <div class="modal-top">
            <p class="modal-title">信息</p>
            <img src="../assets/cancel.png" class="close" @click="hideModal" />
          </div>

          <div class="modal-main">{{ message }}</div>
          <div class="modal-bottom">
            <p class="confirmBtn" @click="hideModal">确定</p>
          </div>
        </div>
      </div>
    </main>
    <bottomFooter />
  </div>
</template>

<style>
/* 联系我们 */
.sites {
  /* width: 61.5%; */
  width: 72.375rem;
  max-width: 72.375rem;
  max-height: 55.375rem;
}

@media screen and (max-width: 1300px) {
  .sites {
    width: 85% !important;
  }

  .list {
    width: 92% !important;
    padding-bottom: 0 !important;
  }

  .contact-item {
    margin-bottom: 4.6rem !important;
  }

  .contact-item:first-of-type {
    /* margin: 2rem 0 6.3125rem; */
    margin: 1.8rem 0 6.2rem !important;
  }
}

@media screen and (max-width: 1200px) {
  .sites {
    width: 85% !important;
  }

  .list {
    width: 92% !important;
    padding-bottom: 0 !important;
  }

  .contact-item {
    /* font-size: 1.75rem; */
    line-height: 1.6rem !important;
    font-size: 1.6rem !important;
    margin-bottom: 3.5rem !important;
  }

  .contact-item:first-of-type {
    /* margin: 2rem 0 6.3125rem; */
    margin: 1.8rem 0 5.5rem !important;
  }

  .contact-item .desc {
    line-height: 1.3rem !important;
    font-size: 1.2375rem !important;
  }
}

@media screen and (min-width: 700px) and (max-width: 900px) {
  .sites {
    width: 85% !important;
  }

  .list {
    width: 92% !important;
    padding-bottom: 0 !important;
  }

  .contact-item {
    /* font-size: 1.75rem; */
    line-height: 1.3rem !important;
    font-size: 1.3rem !important;
    padding-left: 2.5rem !important;
    margin-bottom: 3rem !important;
  }

  .contact-item:first-of-type {
    /* margin: 2rem 0 6.3125rem; */
    margin: 1.7rem 0 4.5rem !important;
  }

  .contact-item .desc {
    line-height: 1.2rem !important;
    font-size: 1.1375rem !important;
  }

  .contactBtn {
    height: 4.5rem !important;
    line-height: 1.5rem !important;
    font-size: 1.6rem !important;
  }
  .contactBtn span {
    height: 1.5rem !important;
  }
}

@media screen and (max-width: 766px) {
  .formGroup3 {
    margin-bottom: 1.0625rem !important;
  }
}

@media (max-width: 699px) {
  .sites {
    width: 85% !important;
  }

  .list {
    width: 95% !important;
    padding-bottom: 0 !important;
  }

  .contact-item {
    /* font-size: 1.75rem; */
    line-height: 1rem !important;
    font-size: 1rem !important;
    padding-left: 0.5rem !important;
    margin-bottom: 2rem !important;
  }

  .contact-item:first-of-type {
    /* margin: 2rem 0 6.3125rem; */
    margin: 1.7rem 0 3rem !important;
  }

  .contact-item .desc {
    line-height: 0.8rem !important;
    font-size: 0.65rem !important;
  }

  .contactBtn {
    height: 4rem !important;
    line-height: 1.3rem !important;
    font-size: 1.5rem !important;
    padding: 0 8% !important;
  }

  .contactBtn span {
    height: 1.3rem !important;
  }
  .msgnote {
    padding: 0 2% !important;
  }
}

@media (max-width: 499px) {
  .sites {
    width: 85% !important;
  }

  .container-fluid,
  .col-2,
  .col-8 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .list {
    width: 96% !important;
    border: 0.125rem solid #e4e4e4 !important;
    padding-bottom: 0 !important;
    margin-left: 2% !important;
    margin-right: 2% !important;
  }

  .contact-item {
    /* font-size: 1.75rem; */
    line-height: 0.9rem !important;
    font-size: 0.9rem !important;
    padding-left: 0.2rem !important;
    margin-bottom: 1.6rem !important;
  }

  .contact-item:first-of-type {
    /* margin: 2rem 0 6.3125rem; */
    margin: 1.7rem 0 2.4rem !important;
  }

  .contact-item .desc {
    line-height: 0.8rem !important;
    font-size: 0.7rem !important;
    padding: 0 2% !important;
  }

  .contactBtn {
    height: 3rem !important;
    line-height: 1rem !important;
    font-size: 1.2rem !important;
    padding: 0 3% !important;
  }

  .contactBtn span {
    height: 1rem !important;
  }

  .contactBtn img {
    width: 2rem !important;
    height: 0.8rem !important;
    margin-left: 0.6rem !important;
  }

  .msgnote {
    line-height: 1.2rem !important;
    font-size: 0.9rem !important;
    padding: 0 2% !important;
    margin-bottom: 2rem !important;
  }

  .formCont {
    width: 100%;
    padding: 0 2% !important;
  }

  .formGroup3 {
    margin-bottom: 1.0625rem !important;
  }
}
.contact .cont {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.list {
  /* width: 64%; */
  /* height: 91.6875rem; */
  width: 75.3125rem;
  border: 0.375rem solid #e4e4e4;
  padding-bottom: 2.875rem;
}

.list::-webkit-scrollbar {
  display: none;
}

.contact-item {
  display: flex;
  align-items: center;
  width: 100%;
  line-height: 1.75rem;
  font-size: 1.75rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  text-align: left;
  color: #333333;
  margin-bottom: 4.625rem;
  margin-right: 0 !important;
  margin-left: 0 !important;
  padding-left: 2.9375rem;
  box-sizing: border-box;
}

.contact-item .area {
  padding: 0;
}

.contact-item .desc {
  line-height: 1.5rem;
  font-size: 1.4375rem;
  padding: 0;
}

.contact-item:first-of-type {
  margin: 2rem 0 6.3125rem;
}

.contact-item:last-of-type {
  margin-bottom: 0;
}

/* 在线留言 */
.msgnote {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  line-height: 1.75rem;
  font-size: 0.9375rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  text-align: center;
  color: #333333;
  margin-bottom: 3.0625rem;
}

/* 表单 */
.form-row {
  margin-left: 0;
}

.form-row > [class*="col-"]:first-of-type {
  padding-left: 0;
}

.form-row > [class*="col-"]:last-of-type {
  padding-right: 0;
}

.formGroup4 {
  margin-bottom: 1.0625rem !important;
}

.form-group > label {
  line-height: 15px;
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-bottom: 19px;
}

.form-group > input {
  height: 41px;
  background: #f2f3f5;
  border-radius: 5px;
  border: none;
  outline: none;
}

.form-control:focus {
  background: #f2f3f5;
  border-color: transparent;
  box-shadow: none;
}

.form-group > textarea {
  background: #f2f3f5;
  border-radius: 5px;
  border: none;
}

.flexStart {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.msgnote p {
  margin-bottom: 0;
}

.contactBtn {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 4.6875rem;
  line-height: 1.75rem;
  font-size: 1.8125rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  background: #020e62;
  border-radius: 0.5rem;
  margin: 2.375rem auto 1.375rem;
  padding: 0 13%;
  box-sizing: border-box;
}

.contactBtn img {
  width: 2.375rem;
  height: 1.0625rem;
  margin-left: 0.75rem;
}

.contactBtn span {
  height: 1.75rem;
}

.modal-bg {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
}

.modal-container {
  width: 17.5rem;
  border-radius: 0.3125rem;
  background: #fff;
}

.modal-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 3.125rem;
  line-height: 1rem;
  font-size: 1rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333;
  border-bottom: 1px solid #f2f2f2;
  padding: 0 0.625rem;
  box-sizing: border-box;
}

.modal-top .close {
  width: 0.9375rem;
  height: 0.9375rem;
}

.modal-main {
  text-align: left;
  padding: 1.25rem 2.5rem;
}

.modal-bottom {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  padding-right: 1.25rem;
  margin-bottom: 0.9375rem;
  box-sizing: border-box;
}

.confirmBtn {
  line-height: 0.875rem;
  font-size: 0.875rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #fff;
  background: #020e62;
  padding: 0.625rem 1.25rem;
}
</style>

<script>
import bottomFooter from "@/components/bottomFooter.vue";
import { getBackground, getCity, leaveWord } from "../api/interface"; // 引入接口
export default {
  name: "contactView",
  components: {
    bottomFooter,
  },

  data() {
    return {
      backgroundColor: "",
      fontColor: "",
      scrollTop: 0,
      picture: null,
      showView: false,
      sites: require("../assets/map.png"), //分布图
      cityList: [],
      title: "",
      name: "",
      email: "",
      telephone: "",
      telephone1: "",
      desc: "",
      message: "",
      isShow4: false, //是否展示消息弹窗
      isCollapse: true, //是否折叠导航条
      bgimg1: require("../assets/collapse.png"),
      bgimg2: require("../assets/close1.png"),
    };
  },

  created() {
    this.getImg();
    this.getCity();
  },

  mounted() {
    //首先，在mounted钩子window添加一个滚动滚动监听事件
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    //然后在方法中，添加这个handleScroll方法来获取滚动的位置
    handleScroll() {
      // let scrollTop =
      //   window.pageYOffset ||
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop;
      let scrollTop = document.documentElement.scrollTop;

      console.log("scrollTop", scrollTop);

      //设置页面滚动时目录导航栏的背景颜色
      if (scrollTop > 100) {
        this.$set(this, "scrollTop", scrollTop);
        this.$set(this, "backgroundColor", "#fff");
        this.$set(this, "fontColor", "#000000!important");
      } else {
        this.$set(this, "scrollTop", scrollTop);
        this.$set(this, "backgroundColor", "rgba(0, 0, 0, 0.1)");
        this.$set(this, "fontColor", "#ffffff");
      }
      console.log(this.fontColor);
    },

    // 折叠导航栏
    collapseNav() {
      const that = this;
      that.$set(that, "isCollapse", !that.isCollapse);
    },

    // 获取图片数据
    async getImg() {
      const that = this;
      await getBackground({ P_INFO: "contact-us" }).then((res) => {
        console.log(res);
        if (res.state == "success") {
          that.$set(that, "picture", res.picture);
          if (that.picture != null) {
            that.$set(that, "showView", true);
          }
        }
      });
    },

    // 获取城市信息列表
    async getCity() {
      const that = this;
      await getCity().then((res) => {
        console.log(res);
        if (res.state == "success") {
          that.$set(that, "cityList", res.city);
        }
      });
    },

    // 是否展示消息弹窗
    hideModal() {
      this.$set(this, "isShow4", false);
    },

    // 提交表单
    submit(e) {
      e.preventDefault(); // 阻止默认提交行为
      console.log(
        this.title,
        this.name,
        this.email,
        this.telephone,
        this.telephone1,
        this.desc
      );
      var regMobile = /^1[34578]\d{9}$/; //或者为/^1[3|4|5|7|8][0-9]\d{8}$/;
      var regEmail = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/; //邮箱验证
      //   固定电话验证格式为0510-88128803、010-58128512
      // var regPhone = /\d{3}-\d{8}|\d{4}-\d{8}/;
      if (
        this.title == "" ||
        this.name == "" ||
        this.email == "" ||
        this.telephone == "" ||
        this.desc == ""
      ) {
        this.$set(this, "message", "请填写完必填信息！");
        this.$set(this, "isShow4", true);
      } else if (!regMobile.test(this.telephone)) {
        this.$set(this, "message", "手机号格式不正确！");
        this.$set(this, "isShow4", true);
      } else if (this.telephone1 != "" && this.telephone1.length > 13) {
        this.$set(this, "message", "固定电话格式不正确！");
        this.$set(this, "isShow4", true);
      } else if (!regEmail.test(this.email)) {
        this.$set(this, "message", "邮箱格式不正确！");
        this.$set(this, "isShow4", true);
      } else {
        let params = {
          LW_TITLE: this.title,
          LW_NAME: this.name,
          LW_PHONE: this.telephone,
          LW_EMAIL: this.email,
          LW_FIXED_LINE: this.telephone1,
          LW_NOTE: this.desc,
        };
        const that = this;
        leaveWord(params).then((res) => {
          console.log(res);
          if (res.state == "success") {
            that.$set(that, "message", "留言成功！");
            that.$set(that, "isShow4", true);
          }
        });
      }
    },
  },

  //由于是在整个window中添加的事件，所以要在页面离开时摧毁掉，否则会报错
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
